export default {

  // 获取地址code
  getAddressCode(addressData) {
    const codeKey = {
      provinceCodeKey: 'province_code',
      cityCodeKey: 'city_code',
      countyCodeKey: 'county_code',
    };

    return {
      provinceCode: String(addressData[codeKey.provinceCodeKey] || ''),
      cityCode: String(addressData[codeKey.cityCodeKey] || ''),
      countyCode: String(addressData[codeKey.countyCodeKey] || ''),
    };
  },

  /**
   * 之前是直接传递一个地址对象就可以获取地址,但是因为要改为从服务器拉取最新的地址,所以将参数加上了region,
   * 但是因为有些页面中直接调用了getAddress方法,导致在刷新之后不能直接显示地址,而是需要再次操作之后才有地址
   * 所以这个region一定是组件的data中获取的
   *
   * 虽然在用到这个方法的所有组件中都调用了一个异步加载地址的方法,但是方法有缓存,不会调用多次
   *
   * 给函数加了个mode参数，当参数为"Object"时，返回一个各个地址的对象。当不传参数或者为"String"时，返回拼接后的字符串
   */
  getAddress(region, addressData, mode) {
    const { provinceCode, cityCode, countyCode } = ((addressData) => {
      const codeKey = {
        provinceCodeKey: 'province_code',
        cityCodeKey: 'city_code',
        countyCodeKey: 'county_code',
      };

      return {
        provinceCode: String(addressData[codeKey.provinceCodeKey] || ''),
        cityCode: String(addressData[codeKey.cityCodeKey] || ''),
        countyCode: String(addressData[codeKey.countyCodeKey] || ''),
      };
    })(addressData);
    const detailAddress = addressData.detail_address || '';

    if (!region['86'] || !region['86'][provinceCode]) {
      return detailAddress;
    }

    const province = region['86'][provinceCode];

    if (!region[provinceCode] || !region[provinceCode][cityCode]) {
      return `${province}${detailAddress}`;
    }

    const city = region[provinceCode][cityCode];

    if (!region[cityCode] || !region[cityCode][countyCode]) {
      return `${province}${city}${detailAddress}`;
    }

    const county = region[cityCode][countyCode] || '';

    mode = mode || 'String';

    if (mode === 'Object') {
      return {
        province,
        city,
        county,
        detailAddress,
      };

    }
    return `${province}${city}${county}${detailAddress}`;


  },

};




// WEBPACK FOOTER //
// ./src/libs/address-utils.js